import * as React from 'react';
import { Route, Switch } from 'react-router';
import Layout from './components/Layout';
import ConsoleLayout from './components/Console/ConsoleLayout';
import Home from './components/Home';
import Dashboard from './components/Console/Dashboard';
import LicenseManagerLayout from './components/LicenseManager/LicenseManagerLayout';
import LicenseManagerDashboard from './components/LicenseManager/LicenseManagerDashboard';
import UserManagementDashboard from './components/UserManagement/UserManagementDashboard';
import AdminLayout from './components/Admin/AdminLayout';
import AdminDashboard from './components/Admin/AdminDashboard';
import LoggedOut from './components/LoggedOut';
import SamlError from './components/Error/SamlError';
import './custom.css';
import DashboardManagement from './components/Admin/DashboardManagement';
import IdpList from './components/Management/IdpList';
import RoleList from './components/RoleManagement/RoleList';
import ReportsLayout from './components/Console/ReportsLayout';
import UserDashboards from './components/Console/UserDashboards';
import { setupSessionIdleRefresh, isAuthenticated } from './utils';
import { syncChatbotAuthSession } from './ApiUtils/session';
import ChatbotFloatingWidget from './components/Console/ChatbotFloatingWidget';

const App = () => {
    setupSessionIdleRefresh();

    // Runs before the widget mounts, so a fresh sign-in never reads a previous
    // session's chat out of localStorage.
    const authenticated = isAuthenticated();
    syncChatbotAuthSession(authenticated);

    return (
        <>
            <Switch>
                <Route path={['/console']}>
                    <ConsoleLayout>
                        <Dashboard />
                    </ConsoleLayout>
                </Route>
                <Route path={['/license-manager']}>
                    <LicenseManagerLayout>
                        <LicenseManagerDashboard />
                    </LicenseManagerLayout>
                </Route>
                <Route path={['/admin']}>
                    <AdminLayout>
                        <Switch>
                            <Route path="/admin">
                                <Route exact path="/admin/dashboard" component={AdminDashboard} />
                                <Route exact path="/admin/dashboard-management" render={(props) => <DashboardManagement props />}   />
                                <Route exact path="/admin/management/portal-settings/company" render={(props) => <IdpList {...props} />} />
                                <Route exact path="/admin/user_management" component={UserManagementDashboard} />
                                <Route exact path="/admin/user_management/dashboard" component={UserManagementDashboard} />
                                <Route exact path="/admin/role-management" component={RoleList} />
                            </Route>
                        </Switch>
                    </AdminLayout>
                </Route>
                <Route path={['/data-intelligence']}>
                    <ReportsLayout>
                        <Switch>
                            <Route path="/data-intelligence">
                                <Route exact path="/data-intelligence/policy-monitoring" component={UserDashboards} />
                            </Route>
                        </Switch>
                    </ReportsLayout>
                </Route>
                <Route path={['/LoggedOut']}>
                    <LoggedOut />
                </Route>
                <Route path={['/error/saml']}>
                    <Layout>
                        <SamlError />
                    </Layout>
                </Route>
                <Route path={['/']}>
                    <Layout>
                        <Route exact path='/' component={Home} />
                    </Layout>
                </Route>
            </Switch>
            {authenticated && (
                <ChatbotFloatingWidget
                    title="AI Assistant"
                    iconUrl="resources/gds_logo_new.png"
                    iconSize={24}
                    showIconInHeader
                    showIconOnToggle
                />
            )}
        </>
    );
};

export default App;
